import type { SpeedFactor } from '@bringg/dashboard-sdk/dist/SpeedFactor/Service/SpeedFactor.service';

export enum SpeedFactorGroupType {
	UtcMidnightSplit = 'utc_midnight_split'
}

export type SpeedFactorOriginalEventShared = Pick<
	SpeedFactor,
	| 'id'
	| 'factor'
	| 'start_date'
	| 'end_date'
	| 'service_area_id'
	| 'interval_start'
	| 'interval_end'
	| 'day_of_week'
	| 'original_uuid'
>;

type WrapGroup<T extends { groupType: SpeedFactorGroupType }> = T & SpeedFactorOriginalEventShared;

export type SpeedFactorUtcMidnightSplitData = {
	groupType: SpeedFactorGroupType.UtcMidnightSplit;
	start: SpeedFactor;
	end: SpeedFactor;
};
export type SpeedFactorUtcMidnightSplitGroup = WrapGroup<SpeedFactorUtcMidnightSplitData>;

export type SpeedFactorGroup = SpeedFactor | SpeedFactorUtcMidnightSplitGroup;
